import { COLORS } from '@btime/constants'
import React from 'react'

import { InfoIconTooltip } from '../../../../../../components/helpers/InfoIconTooltip'
import { Label, Paragraph } from '../../../../../../packages/kiti/components/presentation/Text'

/**
 * Ícone "i" com tooltip (aparece ao passar o mouse) usado pelo modal "Atualizar Atividade" para mostrar as
 * orientações/regras de cada campo sem ocupar espaço fixo na tela. `info` aceita um texto ou uma lista de textos
 * (cada um vira um parágrafo no tooltip). Reaproveita `InfoIconTooltip`, o mesmo ícone das demais telas.
 */
export const InfoIcon = ({ info }) => {
  const paragraphs = [].concat(info).filter(Boolean)
  if (!paragraphs.length) return null

  return (
    <InfoIconTooltip maxWidth="20rem" style={{ display: 'flex', alignItems: 'center', cursor: 'help' }}>
      {paragraphs.map(text => (
        <Paragraph key={text} size="small" color={COLORS.white}>
          {text}
        </Paragraph>
      ))}
    </InfoIconTooltip>
  )
}

/**
 * Linha com um título (qualquer elemento de texto) + ícone "i" ao lado.
 */
export const InfoRow = ({ children, info, marginBottom = '0' }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom }}>
    {children}
    <InfoIcon info={info} />
  </div>
)

/**
 * Rótulo de campo com ícone "i" ao lado. Use junto com `FormItem ignoreLabel` (o rótulo é desenhado aqui, fora do
 * <p> do `Label` do FormItem, porque o tooltip usa <div>). Sem `info`, renderiza só o rótulo.
 */
const InfoLabel = ({ label, info }) => (
  <InfoRow info={info} marginBottom="0.4rem">
    <Label marginBottom={0}>{label}</Label>
  </InfoRow>
)

export default InfoLabel
